export default {
  "--color-primary": "rgb(227, 97, 100)",
  "--color-primary-active": "rgb(224, 82, 84)",
  "--color-tertiary": "rgb(36, 103, 58)",
  "--color-tertiary-active": "rgb(28, 88, 47)",
  "--text-color-link": "rgb(227, 97, 100)",
  "--text-color-link-active": "rgb(224, 82, 84)",
  "--text-color-primary": "rgb(227, 97, 100)",
  "--background-color-primary": "rgb(227, 97, 100)",
  "--background-color-primary-active": "rgb(224, 82, 84)",
  "--background-input-base": "rgb(224, 228, 235)",
  "--border-color-active": "rgb(227, 97, 100)",
  "--border-color-primary": "rgb(227, 97, 100)"
};